import { SiteAuditorRouteConfig } from '@/modules/seo/siteauditor/SiteAuditorRouteConfig';
import { ENABLE_CLIENT, WebsiteRouteNames } from '@/modules/seo/website/website.constants';

export const router = SiteAuditorRouteConfig.factory([
  {
    path: '/raven/websites/:id(\\d+)/siteauditor',
    name: WebsiteRouteNames.SITE_AUDITING,
    component: () => {
      if (ENABLE_CLIENT) {
        return import(
          /* webpackChunkName: "website-inner-page-with-client" */ '../website/pages/WebsiteInnerPageWithClient.vue'
        );
      }
      return import(
        /* webpackChunkName: "website-inner-page" */ '../website/pages/WebsiteInnerPage.vue'
      );
    },
    props: true,
  },
  {
    path: '/raven/websites/:id(\\d+)/siteauditor/pagespeed/:deviceType',
    name: WebsiteRouteNames.PAGE_SPEED_INSIGHTS,
    component: () => {
      if (ENABLE_CLIENT) {
        return import(
          /* webpackChunkName: "website-inner-page-with-client" */ '../website/pages/WebsiteInnerPageWithClient.vue'
        );
      }
      return import(
        /* webpackChunkName: "website-inner-page" */ '../website/pages/WebsiteInnerPage.vue'
      );
    },
    props: true,
  },
  {
    path: '/raven/websites/:id(\\d+)/siteauditor/:issueType',
    name: WebsiteRouteNames.ISSUE_DETAILS,
    component: () => {
      if (ENABLE_CLIENT) {
        return import(
          /* webpackChunkName: "website-inner-page-with-client" */ '../website/pages/WebsiteInnerPageWithClient.vue'
        );
      }
      return import(
        /* webpackChunkName: "website-inner-page" */ '../website/pages/WebsiteInnerPage.vue'
      );
    },
    props: true,
  },
]);
